var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYandex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#242729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9515 6.99709C11.7802 8.43707 10.2608 10.6718 9.72028 13.2205C9.17974 15.7692 9.66121 18.4283 11.0611 20.6257C12.461 22.823 14.6674 24.3831 17.2058 24.9703C19.7442 25.5576 22.4116 25.125 24.6343 23.7657L39.2257 14.4699C38.2235 10.9974 36.3005 7.86075 33.6605 5.39229C31.0206 2.92383 27.7619 1.21556 24.23 0.448517L13.9515 6.99709Z",
    fill: "#FF9D7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9515 6.99709C11.7802 8.43707 10.2608 10.6718 9.72028 13.2205C9.17974 15.7692 9.66121 18.4283 11.0611 20.6257C12.461 22.823 14.6674 24.3831 17.2058 24.9703C19.7442 25.5576 22.4116 25.125 24.6343 23.7657L39.2257 14.4699C38.2235 10.9974 36.3005 7.86075 33.6605 5.39229C31.0206 2.92383 27.7619 1.21556 24.23 0.448517L13.9515 6.99709Z",
    fill: "#FF6432"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9515 6.99709C11.7802 8.43707 10.2608 10.6718 9.72028 13.2205C9.17974 15.7692 9.66121 18.4283 11.0611 20.6257C12.461 22.823 14.6674 24.3831 17.2058 24.9703C19.7442 25.5576 22.4116 25.125 24.6343 23.7657L39.2257 14.4699C38.2235 10.9974 36.3005 7.86075 33.6605 5.39229C31.0206 2.92383 27.7619 1.21556 24.23 0.448517L13.9515 6.99709Z",
    fill: "url(#paint0_radial_63_712)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9515 6.99709C11.7802 8.43707 10.2608 10.6718 9.72028 13.2205C9.17974 15.7692 9.66121 18.4283 11.0611 20.6257C12.461 22.823 14.6674 24.3831 17.2058 24.9703C19.7442 25.5576 22.4116 25.125 24.6343 23.7657L39.2257 14.4699C38.2235 10.9974 36.3005 7.86075 33.6605 5.39229C31.0206 2.92383 27.7619 1.21556 24.23 0.448517L13.9515 6.99709Z",
    fill: "url(#paint1_linear_63_712)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.771484 25.5199L15.3686 16.2199C16.4698 15.5184 17.6983 15.0407 18.984 14.8141C20.2698 14.5874 21.5876 14.6162 22.8622 14.8988C24.1368 15.1814 25.3433 15.7124 26.4127 16.4612C27.4821 17.2101 28.3936 18.1623 29.0951 19.2634C29.7965 20.3646 30.2742 21.5931 30.5009 22.8788C30.7275 24.1646 30.6987 25.4824 30.4161 26.757C30.1335 28.0316 29.6026 29.2381 28.8537 30.3075C28.1048 31.377 27.1526 32.2884 26.0515 32.9899L15.7558 39.5484C12.2251 38.7789 8.96828 37.0688 6.33037 34.5991C3.69246 32.1295 1.77167 28.9923 0.771484 25.5199Z",
    fill: "#FFE66E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.771484 25.5199L15.3686 16.2199C16.4698 15.5184 17.6983 15.0407 18.984 14.8141C20.2698 14.5874 21.5876 14.6162 22.8622 14.8988C24.1368 15.1814 25.3433 15.7124 26.4127 16.4612C27.4821 17.2101 28.3936 18.1623 29.0951 19.2634C29.7965 20.3646 30.2742 21.5931 30.5009 22.8788C30.7275 24.1646 30.6987 25.4824 30.4161 26.757C30.1335 28.0316 29.6026 29.2381 28.8537 30.3075C28.1048 31.377 27.1526 32.2884 26.0515 32.9899L15.7558 39.5484C12.2251 38.7789 8.96828 37.0688 6.33037 34.5991C3.69246 32.1295 1.77167 28.9923 0.771484 25.5199Z",
    fill: "url(#paint2_linear_63_712)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_63_712",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4029 27.8657) rotate(-34.8829) scale(23.9486 17.6243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0700",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#CC0700",
    stopOpacity: 0.962
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#CC0700",
    stopOpacity: 0.936
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CC0700",
    stopOpacity: 0.891
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#CC0700",
    stopOpacity: 0.827
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#CC0700",
    stopOpacity: 0.745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CC0700",
    stopOpacity: 0.648
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#CC0700",
    stopOpacity: 0.541
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#CC0700",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CC0700",
    stopOpacity: 0.322
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#CC0700",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#CC0700",
    stopOpacity: 0.143
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CC0700",
    stopOpacity: 0.079
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#CC0700",
    stopOpacity: 0.034
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#CC0700",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC0700",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_63_712",
    x1: 16.6872,
    y1: 22.7171,
    x2: 30.5586,
    y2: -10.7643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#FF8140",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#FF8140",
    stopOpacity: 0.036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF8140",
    stopOpacity: 0.082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#FF8140",
    stopOpacity: 0.147
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FF8140",
    stopOpacity: 0.232
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF8140",
    stopOpacity: 0.332
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF8140",
    stopOpacity: 0.443
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#FF8140",
    stopOpacity: 0.557
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF8140",
    stopOpacity: 0.668
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#FF8140",
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#FF8140",
    stopOpacity: 0.853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF8140",
    stopOpacity: 0.918
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#FF8140",
    stopOpacity: 0.964
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#FF8140",
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_63_712",
    x1: 17.2829,
    y1: 22.6642,
    x2: 4.10005,
    y2: 41.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD750",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD750"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.21e7c998898fc96cf05b1f56b5f8aee9.svg";
export { ForwardRef as ReactComponent };